import { alpha, Box, Skeleton, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import PendingButton from "../buttons/pending_button";
import { DefaultButton, ErrorButton } from "..";

export default function UserLoadingItemWidget({ id }) {
    const { mode } = useColorScheme();

    const currentMode = mode || "system";
    return (
        <Stack key={id}
            direction={{
                xs: "column",
                sm: "row",
            }}
            alignItems={{
                xs: "start",
                sm: "center",
            }}
            justifyContent={"space-between"}
            sx={{
                padding: {
                    xs: `calc(${Constants.Styles.spacing} * 1)`,
                    sm: `calc(${Constants.Styles.spacing} * 4)`,
                },
                backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.3),
                border: `1px solid ${Constants.Colors[currentMode].border}`,
                borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
            }}
        >
            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                spacing={"1.125rem"}
            >
                <Skeleton
                    variant="circular"
                    width={40}
                    height={40}
                />
                <Skeleton
                    variant="text"
                    width={120}
                    height={20}
                />
            </Stack>
            <Skeleton
                variant="rounded"
                width={140}
                height={30}
            />
        </Stack>
    );
}